/* globals rxSwitchboard */
var jQuery = require('jquery');

// This module implements LP-6488: a UI to remind users about editing
// the form confirmation dialogue. It is a self-contained plugin that
// activates itself upon load and listens for jui events via the
// rxSwitchboard.

;(function(){
  // 2nd class is for old page tabs TODO: remove when removing old tab code
  var tabSelector      = '.tab-bar-tab-form_confirmation a.tab-button, .tab-bar-tab-form'
    , messageSelector  = '.lp-form-review-msg'
    , juiEvents        = rxSwitchboard.subjects.jui_events
    , elementSetEvents = rxSwitchboard.subjects.element_set;

  // ui logic:
  var _getNotificationMsgElem = function() {
    return jQuery(messageSelector);
  };

  var _addNotification = function() {
    var contentType = window.editor.mainPage.settings.contentType;
    var notificationAlignTopClass =
      contentType === 'stickyBar' ? ' align-top' : '';
    var $notificationEl = jQuery(
      '<div class="new-elem-notification lp-form-review-msg' + notificationAlignTopClass + '" />'
    );

    $notificationEl
      .html('<p>Don\'t forget, this dialog can be made responsive too.</p> <a class="close-btn"><span class="icon-close svg-ico-close-dialog"></span></a>');

    $notificationEl.click(function(){
      _markNotificationViewed();
    });

    jQuery('body').append($notificationEl);
    $notificationEl.show();

    _updateNotificationPosition();
  };

  var _shouldShowNotification = function() {
    var page = window.editor.page;
    var form = page ? page.getForm() : undefined;

    return form &&
           form.isVisibleOnPage() &&
           form.model.isConfirmationDialogUsed();
  };
  var _updateNotificationPosition = function() {
    if(_shouldShowNotification()) {
      var formConfTab = jQuery(tabSelector);
      if (formConfTab.length > 0) {
        var formConfTabOffset = formConfTab.offset();
        var notificationMsgElem = _getNotificationMsgElem();

        notificationMsgElem.css({
          left: Math.round(formConfTabOffset.left) + 'px'
        });
      }
    } else {
      _removeNotification();
    }
  };

  var _removeNotification = function() {
    _getNotificationMsgElem().remove();
  };

  // update logic:

  var _updatePageConfirmationTab = function(mainPageRootModel) {
    if( ! mainPageRootModel.safeGet('confirmationViewed')) {
      _addNotification();
    } else {
      _markNotificationViewed();
    }
  };

  var _updateConfirmationPageTabByBreakpoint = function() {
    if(window.editor.page.isMain()) {
      _removeNotification();
      if (window.editor.mainPage.hasForm()) {
        _updatePageConfirmationTab(window.editor.mainPage.getRootElement().model);
      }
    } else {
      _markNotificationViewed();
    }
  };

  var _markNotificationViewed = function() {
    window.editor.mainPage
      .getRootElement().model
      .setOnWritableModelByBreakpoint(
        'confirmationViewed',
        true,
        window.editor.page.getCurrentBreakpoint()
      );

    _removeNotification();
  };

  // event subscriptions:
  var updateNeededEvents = juiEvents
      .filter(function(e) {
        return (e.type === 'elementInserted' ||
                e.type === 'elementRemoved' ||
                e.type === 'breakpointChanged'
               );
      })
      .merge(elementSetEvents
        .filter(function(e){
          return e.type === 'element_model.set' &&
            (e.accessor === 'geometry.visible' ||
            e.accessor === 'content.confirmAction');
        }));

  var updateWhenNeeded = function() {
    updateNeededEvents
      .delay(20)
      .subscribe(_updateConfirmationPageTabByBreakpoint);
  };

  var markViewedOnFormConfirmationEdits = function() {
    juiEvents
      .filter(function(e) {
        return (e.type === 'activePageChanged' && e.data.current.isFormConfirmation());
      })
      .delay(10)
      .subscribe(_markNotificationViewed);
  };

  var updateMessagePositionOnLayoutChanged = function() {
    juiEvents
      .filter(function(e) {return e.type === 'layoutChanged' || e.type === 'loaded';})
      .delay(25)
      .subscribe(_updateNotificationPosition);
  };

  updateWhenNeeded();
  updateMessagePositionOnLayoutChanged();
  markViewedOnFormConfirmationEdits();
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/form_element_manager.js
// module id = 1044
// module chunks = 0